const homeTranslations = {
  welcome: {
    greeting: "Good Morning",
    title: "Welcome Back",
    description:
      "Embrace each meal as a step towards your transformation, for a healthier body ignites the power to reshape your world",
  },
  bodyInfoCard: {
    title: "Body Info",
    encourage: "You are so close to your goal",
  },
  waterInTakeCard: {
    title: "Water in take",
  },
  caloriesCard: {
    title: "Calories",
  },
  mealsCard: {
    title: "Meals",
  },
  snacksCard: {
    title: "Snacks",
  },
  macrosCard: {
    calories: "Calories",
    protein: "Protein",
    carbs: "Carbs",
    fats: "Fats",
  },
  calendar: {
    title: "Calendar",
    actionButton: {
      show: "Show",
      hide: "Hide",
    },
  },
  snacks: "Snacks",
  mealsCategories: {
    title: "Choose Meal Category",
    categories: {
      breakfast: "Meal 1",
      lunch: "Meal 2",
      dinner: "Meal 3",
      dinner2: "Meal 4",
      snacks: "All Snacks",
    },
  },
  mealOption: {
    choose: "Choose One Option For",
    yummy: "Your",
    title: "Macro Nutrients",
    protein: "Protein",
    carb: "Carb",
    fat: "Fat",
    kcals: "Kcals",
    mealsCard: {
      actionButton: "View Meal",
      video: "How To Cook",
    },
  },
};

export default homeTranslations;
